export const formatDate = (dateString) => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour12: true,
  });
};

export const formatDateWithTime = (dateString) => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit", // Optional, remove if you don't want seconds
    hour12: true,
  });
};